import { message } from 'antd'
import { OrdersApi } from '../../../../api/Purchase/Orders'
import LinesImport from '../../../../components/Purchasing/Order/ImportLines/LinesImport'
import useModalData from '../../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import React from 'react'

function LinesImportCont (props) {
  const { order, isUpdatable, fetch } = props
  console.log({ order })
  const { visible, modalType, submitting, setSubmitting, formRef, onShow, onCancel, checkForm } = useModalData()

  async function submit () {
    console.log('clicked')
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await OrdersApi.importLines({
        ...newObject,
        order: pick(order, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <LinesImport
      {...{
        order,
        visible,
        modalType,
        submitting,
        isUpdatable,
        submit,
        formRef,
        onShow,
        onCancel,
      }}
    />
  )
}

export default LinesImportCont
